(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/statistics/helpers/errorhelper.js') >= 0) return;  svs.modules.push('/components/statistics/statistics/helpers/errorhelper.js'); 
(function() {
  'use strict';

  var isServerSide = typeof exports === 'object';

  if (!isServerSide) {
    registerHelpers(Handlebars);
  }

  function registerHelpers(hbs) {
    function noData(customMessage) {
      var message = customMessage ? { message: customMessage } : {};
      return svs.statistics.statistics.templates.nodata(message);
    }

    hbs.registerHelper('showLineup', function(home, away, options) {
      if (
        !!((((home || {}).formation || {}).formationMatrix || {})[0] ||
          {})[0] &&
        !!((((away || {}).formation || {}).formationMatrix || {})[0] || {})[0]
      ) {
        return options.fn(this);
      }
      return noData('Ingen laguppställning är tillgänglig');
    });

    hbs.registerHelper('showEvents', function(data, options) {
      if (
        data.events ||
        data.events.league.length ||
        data.events.goals.length ||
        data.events.cards.length ||
        data.events.favourite.length ||
        data.events.odds.length ||
        data.events.expertPredictions.length ||
        data.events.toppspel.length
      ) {
        return options.fn(this);
      }
      return noData();
    });

    hbs.registerHelper('showStatistics', function(data, options) {
      if (
        data.liveStatistics ||
        data.liveStatistics ||
        data.liveStatistics.matchStatistics.length ||
        data.statistics.latestMeetingsList.length ||
        data.statistics.league.length
      ) {
        return options.fn(this);
      }
      return noData();
    });

    hbs.registerHelper('showMatches', function(matches, options) {
      if (matches) {
        return options.fn(this);
      }
      return noData();
    });

    hbs.registerHelper('showLeagueStatistics', function(
      sortedTeams,
      teams,
      underlyingLeaguesFilter,
      options
    ) {
      if (
        sortedTeams.length > 1 ||
        teams.length > 1 ||
        _.size(underlyingLeaguesFilter) > 0
      ) {
        return options.fn(this);
      }
      return noData();
    });

    hbs.registerHelper('showGeneralTable', function(data, options) {
      if (data.filters && (data.leagueTable || data.leagueTables)) {
        return options.fn(this);
      }
      return noData();
    });

    hbs.registerHelper('showRoster', function(data, options) {
      if ((data.teamRoster || {}).positions) {
        return options.fn(this);
      }
      return noData();
    });

    hbs.registerHelper('showTeamStatistics', function(data, options) {
      if (data.players) {
        return options.fn(this);
      }
      return noData();
    });
  }
})();

 })(window);